import values from 'lodash/values';
import { createSelector } from 'reselect';
import {
    eventsCardInfoLookup,
    getSearchSection,
} from '../../../../../utils/general';

const getSuggestedRawEvents = (state: any) => state.suggestions.rawEvents;
const getCurrencyFormat = (state: any) => state.currencyFormat;
const getIsOnline = (state: any) => state.location.isOnline;

const getSearchSectionSelector = createSelector([getIsOnline], (isOnline) =>
    getSearchSection(isOnline),
);

export const getEventSuggestions: any = createSelector(
    [getSuggestedRawEvents, getCurrencyFormat, getSearchSectionSelector],
    (rawEvents, currencyFormat, section) => {
        const events = values(rawEvents);

        return eventsCardInfoLookup({
            bucketsContent: events,
            currencyFormat,
            section,
        });
    },
);
